export default __webpack_public_path__ + "static/media/clock-icon.f1b3a682.svg";